import _ from 'lodash';
import { HITL as SDK, HITLConfig } from '@or-sdk/hitl';

export class HITL {
  /** Non-empty value for overriding methods during testing */
  public static instance: SDK = {} as any;

  public static initialize(config: HITLConfig) {
    HITL.instance = new SDK(config);
  }

  public static get migrations() {
    return HITL.instance.migrations;
  }

  public static get settings() {
    return HITL.instance.settings;
  }

  public static get agents() {
    return HITL.instance.agents;
  }

  public static get ruleGroups() {
    return HITL.instance.ruleGroups;
  }

  public static get contactRuleGroups() {
    return HITL.instance.contactRuleGroups;
  }

  public static get eventTemplates() {
    return HITL.instance.eventTemplates;
  }

  public static get conferences() {
    return HITL.instance.conferences;
  }

  public static get filters() {
    return HITL.instance.filters;
  }

  public static get cannedMessages() {
    return HITL.instance.cannedMessages;
  }

  public static get sessions() {
    return HITL.instance.sessions;
  }

  public static get sessionEvents() {
    return HITL.instance.sessionEvents;
  }

  public static get listeners() {
    return HITL.instance.listeners;
  }

  public static get contacts() {
    return HITL.instance.contacts;
  }

  public static get contactsMeta() {
    return HITL.instance.contactsMeta;
  }

  public static get commands() {
    return HITL.instance.commands;
  }

  public static get tasks() {
    return HITL.instance.tasks;
  }

  public static get versions() {
    return HITL.instance.versions;
  }

  /** Helper for mocking and testing code, that uses HITL API */
  public static override(path: string, method: () => any) {
    _.set(this.instance, path, method);
  }
}
